import { useEffect } from "react";
import Navigation from "../../../../components/navigations/client/detail/navigation";
import useParentLoaderData from "../../../../hooks/useParentLoaderData";
import ActionItemsTab from "../../../../components/cm/Dashboard/FullPages/ClientDetail/ActionItemsTab";
import { NavigationHistoryService } from "../../../../services/navigation-history-service";

export default () => {
  const { _case } = useParentLoaderData(1);

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/actionable-items");
  }, []);

  return (
    <Navigation activeTab='actionable-items' _case={_case} >
      <div className="overflow-y-auto bg-white rounded-b-[15px] p-4 min-h-[90vh]">
        <ActionItemsTab caseObj={_case}/>
      </div>
    </Navigation>
  );
}





